import React from 'react';
import getValueLabel from '../../workerStore/stack/getDisplayValueLabel';
import {
  Layout,
} from '../../workerStore/stack/Utils';
import Axis from './Axis';
import RibbonLabels from './RibbonLabels';
import {
  bottomMargin,
  IExportInput as IProps,
  leftMargin,
  rightMargin,
  topMargin,
} from './Utils';

export default class extends React.PureComponent<IProps> {
  render() {
    const {
      width, height, ribbons, exportType,
      xAxisMin, xAxisMax, yAxisMin, yAxisMax,
      layout, inflationAdjustment, populationAdjustment,
      tradeDirection, tradeFlow,
    } = this.props;
    const fullWidth = width + leftMargin + rightMargin;
    const fullHeight = height + topMargin + bottomMargin;

    const ribbonElems = ribbons.map(({path, color, id}) => (
      <path d={path} fill={color} key={id}/>
    ));

    const axisLabelSeparationFromEdge = 15;
    /* Start of axis labels */
    const xAxisLabel = (
      <text
        transform={`translate(${width / 2 + leftMargin}, ${fullHeight - axisLabelSeparationFromEdge})`}
        textAnchor='middle' alignmentBaseline='baseline'>
        {__lexiconText('applicationWide.year')}
      </text>
    );

    const yAxisLabelText = (layout === Layout.Share) ?
                    __lexiconText('applicationWide.share') :
                  getValueLabel(inflationAdjustment, populationAdjustment, tradeDirection, tradeFlow);
    const yAxisLabel = (
      <text transform={`translate(${axisLabelSeparationFromEdge}, ${topMargin + height / 2}) rotate(-90)`}
        textAnchor='middle' alignmentBaseline='baseline'>
        {yAxisLabelText}
      </text>
    );
    /* End of axis labels */
    return (
      <svg viewBox={`0 0 ${fullWidth} ${fullHeight}`}
        xmlns='http://www.w3.org/2000/svg'>

        <g transform={`translate(${leftMargin}, ${topMargin})`}>
          <Axis
            xAxisMin={xAxisMin} xAxisMax={xAxisMax}
            yAxisMin={yAxisMin} yAxisMax={yAxisMax}
            layout={layout} width={width} height={height}
            exportType={exportType}
          />
          <g>{ribbonElems}</g>
          <RibbonLabels ribbons={ribbons} exportType={exportType}/>
        </g>
        {xAxisLabel}
        {yAxisLabel}
      </svg>
    );
  }
}
